import React, { useState } from 'react';
import { Box, Grow } from '@material-ui/core';
import useStyle from '../style';
import colorsData from './color';

export default function BoxOptionsColors({ display, setBackgroundImage }) {
  const classes = useStyle();
  const [colors, _] = useState(colorsData);
  return (
    <Grow in={display}>
      <Box className={classes.menu}>
        {colors.map((color) => (
          <Box
            className={classes.box}
            style={{
              backgroundColor: color,
            }}
            onClick={() => setBackgroundImage(color)}
          />
        ))}
      </Box>
    </Grow>
  );
}
